<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{ $t("requests.order.check") }}</div>
                    <div class="card-body">
                        <form-order
                            @order-created="onObjectCreatedPageContext"
                            @order-updated="onRequestUpdated"
                            @request-approved="onRequestApproved"
                            @request-rejected="onRequestRejected"
                            :mode="'approval'"
                            :formdisabled="false"
                            :orderid="this.orderid"
                            :context="context"
                        ></form-order>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "form-approve",
    props: ['user', 'orderid', 'customerId', 'context'],
    data: function(){
        return {
        }
    },
    mounted: function(){

    },
    methods: {
        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag angelegt wurde
         */
        onObjectCreated:function(){
            swal.fire({
                title: this.$t("requests.request-created-title"),
                text: this.$t("requests.request-created-text"),
                icon: "success",
                timer: 5000
            }).then(() => {
                window.location.href = '/request';
                // TODO: Nach dem Senden einer Anfrage fragen was gemacht werden soll. Ggf. Weitere Anfrage?
            });
        },

        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag angelegt wurde - aus dem vollständigen Seitenkontext
         */
        onObjectCreatedPageContext:function(){
            swal.fire({
                title: this.$t("requests.requestpage-created-title"),
                text: this.$t("requests.requestpage-created-text"),
                icon: "success",
                timer: 5000
            }).then(() => {
                window.location.href = '/requests';
                // TODO: Nach dem Senden einer Anfrage fragen was gemacht werden soll. Ggf. Weitere Anfrage?
            });
        },

        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag aktualisiert wurde
         */
        onRequestUpdated:function(){
            swal.fire({
                title: this.$t("requests.updated-title"),
                text: this.$t("requests.updated-text"),
                icon: "success",
                timer: 5000
            }).then(() => {
                this.$router.push({ name: 'dashboard'});
            });
        },

        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag genehmigt wurde
         */
        onRequestApproved:function(){
            swal.fire({
                title: this.$t("requests.approved-title"),
                text: this.$t("requests.approved-text"),
                icon: "success",
                timer: 5000
            }).then(() => {
                if(this.context != "" && this.context != undefined){
                    this.handleBack(this.context, true, {reload: true});
                }else{
                    this.handleBack('dashboard', true, {reload: true});
                }

                // TODO: Nach dem Senden einer Anfrage fragen was gemacht werden soll. Ggf. Weitere Anfrage?
            });
        },

        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag abgelehnt wurde
         */
        onRequestRejected:function(){
            swal.fire({
                title: this.$t("requests.rejected-title"),
                text: this.$t("requests.rejected-text"),
                icon: "warning",
                timer: 5000
            }).then(() => {
                if(this.context != ""){
                    this.handleBack(this.context, true, {reload: true});
                }else{
                    this.handleBack('dashboard', true, {reload: true});
                }
                // TODO: Nach dem Senden einer Anfrage fragen was gemacht werden soll. Ggf. Weitere Anfrage?
            });
        },
    },
}
</script>

<style scoped>

</style>
